import { render, staticRenderFns } from "./FundingSubmissionNotes.vue?vue&type=template&id=59d1d487&"
import script from "./FundingSubmissionNotes.vue?vue&type=script&lang=js&"
export * from "./FundingSubmissionNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports